import React, { Suspense } from 'react';
import { hot } from 'react-hot-loader/root';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import { SwuifApp, Page403, ProtectedRoute } from 'swuif';
import { swuifPreset } from '@/config';
// import Auth from '@/routes/Auth';
import Main from '@/routes/Main';
import Login from '@/routes/Main/Login';
import '@/style/index.less';
import { GlobalContextProvider } from '@/common/GlobalContext/context';

const App = () => {
  return (
    <GlobalContextProvider>
      <SwuifApp {...swuifPreset}>
        <BrowserRouter>
          <Suspense fallback={<div>Loading...</div>}>
            <Switch>
              {/* <Route strict path="/auth" component={Auth} /> */}
              <Route strict path="/forbidden" component={Page403} />
              <Route exact path="/login" component={Login} />
              <ProtectedRoute
                strict
                path="/"
                redirect={{ to: '/login' }}
                component={Main}
              />
            </Switch>
          </Suspense>
        </BrowserRouter>
      </SwuifApp>
    </GlobalContextProvider>
  );
};

export default hot(App);
